// removed by extract-text-webpack-plugin
module.exports = {"remove-icon":"app-pages-Customers-Loyalty-Components-RewardList-__RewardList___-8ah0","list-box":"app-pages-Customers-Loyalty-Components-RewardList-__RewardList___3AVJF"};


//////////////////
// WEBPACK FOOTER
// ./app/pages/Customers/Loyalty/Components/RewardList/RewardList.css
// module id = 828
// module chunks = 0